import { throttle } from 'throttle-debounce';
import { trackSelfDescribingEvent } from '@snowplow/browser-tracker';
import { YA_METRIKA_ID } from '~/constants/config';
import { percentageInit, viewedPagePercent, getPageObject } from '~/utils/PercentagePageElement';

// Скролл всей страницы для Метрики и Snowplow на всех страницах; скролл материала — в лейаутах/страницах.
// Порядок после data-layer ($sendYandexMetrika) задан списком plugins в nuxt.config.ts
export default defineNuxtPlugin({
  setup() {
    const { $sendYandexMetrika, $logger } = useNuxtApp();
    const log = $logger.withScope('🎡 scroll-page-plugin');

    const throttledOnScroll = throttle(100, onScroll);

    percentageInit();

    log('add listener');
    window.addEventListener('scroll', throttledOnScroll);

    function onScroll(): void {
      const pagePercent = viewedPagePercent();
      log('onScroll', pagePercent);

      if (pagePercent) {
        percentageSendAnalytics(getPageObject(), pagePercent);
      }
    }

    function percentageSendAnalytics(
      typeCategory: ReturnType<typeof getPageObject>,
      newValue: number,
    ) {
      const { thresholds, key, category } = typeCategory;

      const viewedThresholds = Object.keys(thresholds)
        .map(Number)
        .filter((threshold) => threshold <= newValue && !thresholds[threshold]);

      viewedThresholds.forEach((threshold) => {
        thresholds[threshold] = true;

        const scrollEventParams = {
          [key]: {
            event: category,
            value: threshold.toString(),
          },
        };

        log('sendAnalytics', scrollEventParams);
        window.ym(YA_METRIKA_ID, 'params', scrollEventParams);

        $sendYandexMetrika({
          level1: 'Скролл страницы',
          level4: threshold.toString(),
        });

        trackSelfDescribingEvent({
          event: {
            schema: 'iglu:dev.snowplow.simple/custom_data/jsonschema/1-0-0',
            data: { pageScroll: threshold.toString() },
          },
        });
      });
    }
  },
});
